import sticker from '@/components/sticker'

export default function(h) {
  if (this.canGetUsers) {
    if (this.hasOwner || this.loading) {
      return h(
        sticker,
        {
          props: this.$_props
        }
      )
    }
  }
}
